const getPartnerUri = () => {
  const isProd = process.env.NODE_ENV === 'production';
  const partnerEnv = process.env.REACT_APP_PARTNER_URI;

  if (isProd) {
    return window.location.origin;
  } else if (partnerEnv) {
    return partnerEnv;
  } else {
    return '';
  }
};

export default getPartnerUri;
